import { keyframes } from "@mui/material";
import React, { useId } from "react";

export const PIECE_SHINE_DURATION_MS = 1500;
export const PIECE_SHINE_CLEANUP_MS = 2000;

const shineLayerFade = keyframes`
  0% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

/**
 * Shine layer rendered inside PieceVisual — same viewBox/size as the piece SVG (pixel-aligned).
 */
export default function PieceLockShineSvg({ path, viewBox, renderSize, viewBoxX, viewBoxY, viewBoxSize }) {
    const reactId = useId().replace(/:/g, "");
    const clipId = `piece-shine-clip-${reactId}`;
    const gradId = `piece-shine-grad-${reactId}`;

    const cx = viewBoxX + viewBoxSize / 2;
    const cy = viewBoxY + viewBoxSize / 2;
    const bandW = viewBoxSize * 0.42;
    const sweepStart = viewBoxX - viewBoxSize * 1.2;
    const sweepEnd = viewBoxX + viewBoxSize * 1.2;

    return (
        <svg
            width={renderSize}
            height={renderSize}
            viewBox={viewBox}
            aria-hidden
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                display: "block",
                pointerEvents: "none",
                overflow: "visible",
                zIndex: 3,
                animation: `${shineLayerFade} ${PIECE_SHINE_DURATION_MS}ms ease-out forwards`,
            }}
        >
            <defs>
                <clipPath id={clipId}>
                    <path d={path} />
                </clipPath>
                <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#ffffff" stopOpacity="0" />
                    <stop offset="35%" stopColor="#fff8dc" stopOpacity="0.15" />
                    <stop offset="50%" stopColor="#ffffff" stopOpacity="0.95" />
                    <stop offset="65%" stopColor="#fff8dc" stopOpacity="0.15" />
                    <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
                </linearGradient>
            </defs>
            <g clipPath={`url(#${clipId})`}>
                <path d={path} fill="rgba(255, 245, 200, 0.62)">
                    <animate
                        attributeName="opacity"
                        from="1"
                        to="0"
                        dur={`${PIECE_SHINE_DURATION_MS}ms`}
                        fill="freeze"
                    />
                </path>
                <rect
                    x={sweepStart}
                    y={viewBoxY - viewBoxSize * 0.2}
                    width={bandW}
                    height={viewBoxSize * 1.4}
                    fill={`url(#${gradId})`}
                    transform={`rotate(32 ${cx} ${cy})`}
                >
                    <animate
                        attributeName="x"
                        from={sweepStart}
                        to={sweepEnd}
                        dur={`${PIECE_SHINE_DURATION_MS}ms`}
                        calcMode="spline"
                        keySplines="0.35 0 0.2 1"
                        keyTimes="0;1"
                        fill="freeze"
                    />
                </rect>
            </g>
        </svg>
    );
}
